<template>
  <div class="settingConfig">
    <el-form :model="marketablePolicyBondForm" ref="marketablePolicyBondForm" label-width="130px">
      <!-- 汽油 -->
      <el-card class="card">
        <span style="display:inline-block;width:200px;font-weight:bold;font-size: large">汽油</span>
        <el-form-item label="订货量梯度" class="add-star">
          <el-row :gutter="20">
            <el-col :span="4" :offset="10"> <div class="nor-text">保证金金额</div></el-col>
          </el-row>
          <el-row :gutter="20" class="pro-row" v-for="(item, index) in marketablePolicyBondForm.ordinaryPro.quotaList" :key="index">
            <el-col :span="10">
              <el-input-number
                v-model="item.minNum"
                controls-position="right"
                :precision="2"
                :min="0"
                :max="999999"
                @change="(currentValue, oldValue)=>marketingPolicySalesChange(currentValue, oldValue,item.minNum,item,'min',index,marketablePolicyBondForm.ordinaryPro.quotaList)">
              </el-input-number>＜= 订货量 ＜ <el-input-number
                v-model="item.maxNum"
                controls-position="right"
                :precision="2"
                :min="0"
                :max="999999"
                @change="(currentValue, oldValue)=>marketingPolicySalesChange(currentValue, oldValue,item.maxNum,item,'max',index,marketablePolicyBondForm.ordinaryPro.quotaList)"></el-input-number>
            </el-col>
            <el-col :span="4">
              <el-input-number
                v-model="item.depositAmount"
                controls-position="right"
                :precision="0"
                :min="0"
                :max="999999">
              </el-input-number>
            </el-col>
            <el-col :span="4">
              <i
                class="el-icon-plus btn-circle btn-add"
                v-if="index === marketablePolicyBondForm.ordinaryPro.quotaList.length - 1"
                @click="addMarketPolicyQuantity(0,item,marketablePolicyBondForm.ordinaryPro.quotaList)"></i>
              <i
                class="el-icon-minus btn-circle btn-del"
                v-if="index === marketablePolicyBondForm.ordinaryPro.quotaList.length - 1"
                @click="delMarketPolicyQuantity(index,0,marketablePolicyBondForm.ordinaryPro.quotaList)"></i>
            </el-col>
          </el-row>
        </el-form-item>
      </el-card>
      <!-- 柴油 -->
      <el-card class="card">
        <span style="display:inline-block;width:200px;font-weight:bold;font-size: large">柴油</span>
        <el-form-item label="订货量梯度" class="add-star">
          <el-row :gutter="20">
            <el-col :span="4" :offset="10"> <div class="nor-text">保证金金额</div></el-col>
          </el-row>
          <el-row :gutter="20" class="pro-row" v-for="(item, index) in marketablePolicyBondForm.highPro.quotaList" :key="index">
            <el-col :span="10">
              <el-input-number
                v-model="item.minNum"
                controls-position="right"
                :precision="2"
                :min="0"
                :max="999999"
                @change="(currentValue, oldValue)=>marketingPolicySalesChange(currentValue, oldValue,item.minNum,item,'min',index,marketablePolicyBondForm.highPro.quotaList)">
              </el-input-number>＜= 订货量 ＜ <el-input-number
                v-model="item.maxNum"
                controls-position="right"
                :precision="2"
                :min="0"
                :max="999999"
                @change="(currentValue, oldValue)=>marketingPolicySalesChange(currentValue, oldValue,item.maxNum,item,'max',index,marketablePolicyBondForm.highPro.quotaList)">
              </el-input-number>
            </el-col>
            <el-col :span="4">
              <el-input-number
                v-model="item.depositAmount"
                controls-position="right"
                :precision="0"
                :min="0"
                :max="999999">
              </el-input-number>
            </el-col>
            <el-col :span="4">
              <i
                class="el-icon-plus btn-circle btn-add"
                v-if="index === marketablePolicyBondForm.highPro.quotaList.length - 1"
                @click="addMarketPolicyQuantity(1,item,marketablePolicyBondForm.highPro.quotaList)"></i>
              <i
                class="el-icon-minus btn-circle btn-del"
                @click="delMarketPolicyQuantity(index,1,marketablePolicyBondForm.highPro.quotaList)"></i>
            </el-col>
          </el-row>
        </el-form-item>
      </el-card>
      <el-card>
        <el-form-item>
          <template>
            <el-button type="primary" @click="onSaveMarketPolicy" v-permission="'0174401'">保 存</el-button>
          </template>
        </el-form-item>
      </el-card>
    </el-form>
  </div>
</template>
<script>
import SearchSelect from '@/components/searchSelect/index'
import { mapActions } from 'vuex'
export default {
  name: 'protocolPolicySetting',
  components: { SearchSelect },
  data () {
    return {
      marketablePolicyBondForm: {
        // 基础产品
        ordinaryPro: {
          // 配置的额度
          quotaList: [
            {
              minNum: 0,
              maxNum: 0,
              immediate: 0,
              depositAmount: 0
            }
          ]
        },
        // 高端产品
        highPro: {
          // 配置的额度
          quotaList: [
            {
              minNum: 0,
              maxNum: 0,
              immediate: 0,
              depositAmount: 0
            }
          ]
        }
      }
    }
  },
  mounted () {
    this.getArgeementSetting(9)
  },
  methods: {
    ...mapActions(['getArgeementPolocy', 'saveArgeementPolocy']),
    marketingPolicySalesChange (currentValue, oldValue, val, item, type, index, quotaList) {
      for (let i = 0; i < quotaList.length; i++) {
        let subItem = quotaList[i]
        if (currentValue > subItem.minNum && currentValue < subItem.maxNum) {
          this.$message({
            message: '订货量值与其他配置存在交叉，请重新设置',
            type: 'warning'
          })
          this.$nextTick(() => {
            if (type === 'min') {
              // 如果这个值小于上一个配置的最大值，将值置为上一个值得最大值
              let lastItem = quotaList[ index - 1 ]
              if (lastItem && lastItem !== undefined && lastItem !== null) {
                if (currentValue < lastItem.maxNum) {
                  item.minNum = lastItem.maxNum
                  if (!item.maxNum || item.maxNum === 0 || item.maxNum === undefined) {
                    this.$nextTick(() => {
                      item.maxNum = item.minNum
                    })
                  }
                  return
                }
              }
              item.minNum = oldValue
            } else {
              // 如果这个值小于上一个配置的最大值，将值置为上一个值得最大值
              let lastItem = quotaList[ index - 1 ]
              if (lastItem && lastItem !== undefined && lastItem !== null) {
                if (currentValue < lastItem.maxNum) {
                  item.maxNum = lastItem.maxNum
                  if (!item.minNum || item.minNum === 0 || item.minNum === undefined) {
                    this.$nextTick(() => {
                      item.minNum = item.minNum
                    })
                  }
                  return
                }
              }
              item.maxNum = oldValue
            }
          })
          return
        }
      }
      if (type === 'min') {
        if (!item.maxNum || item.maxNum === 0 || item.maxNum === undefined) {
          this.$nextTick(() => {
            item.maxNum = val + 0.01
          })
        } else {
          if (item.minNum > item.maxNum) {
            this.$message({
              message: '订货量最小值不能大于订货量最大值',
              type: 'warning'
            })
            this.$nextTick(() => {
              item.minNum = oldValue
            })
          } else {
            // 校验这个值
            this.$nextTick(() => {
              item.minNum = currentValue
            })
          }
        }
      } else {
        if (val < item.minNum) {
          this.$message({
            message: '订货量最大值不能小于订货量最小值',
            type: 'warning'
          })
          this.$nextTick(() => {
            item.maxNum = item.minNum + 0.01
          })
        } else {
          this.$nextTick(() => {
            item.maxNum = currentValue
          })
        }
      }
    },
    // 新增
    addMarketPolicyQuantity (type, item, list) {
      let minNum = 0
      if (!item || item === undefined || item === null || item === '') {
        minNum = 0
        //
        this.$message({
          message: '请添加一个订货量梯度之后再增加新的梯度',
          type: 'warning'
        })
        return
      } else {
        minNum = item.maxNum ? item.maxNum : 0
      }
      if (type === 0) {
        list.push({
          minNum: minNum,
          maxNum: minNum + 0.01,
          immediate: 0,
          depositAmount: 0
        })
      } else if (type === 1) {
        list.push({
          minNum: minNum,
          maxNum: minNum + 0.01,
          immediate: 0,
          depositAmount: 0
        })
      }
    },
    // 删除
    delMarketPolicyQuantity (index, type, list) {
      if (type === 0) {
        if (list.length === 1) {
          this.$set(list, 0, {
            minNum: 0,
            maxNum: 0,
            immediate: 0,
            depositAmount: 0
          })
          return
        }
        list.splice(index, 1)
      } else if (type === 1) {
        if (list.length === 1) {
          this.$set(list, 0, {
            minNum: 0,
            maxNum: 0,
            immediate: 0,
            depositAmount: 0
          })
          return
        }
        list.splice(index, 1)
      }
    },
    onSaveMarketPolicy () {
      for (let i = 0; i < this.marketablePolicyBondForm.ordinaryPro.quotaList.length; i++) {
        let item = this.marketablePolicyBondForm.ordinaryPro.quotaList[i]
        if (item.minNum === '' || item.minNum === undefined || item.maxNum === '' || item.maxNum === undefined || item.immediate === '' || item.immediate === undefined || item.depositAmount === '' || item.depositAmount === undefined) {
          this.$message.error('请填写完整信息')
          return
        }
      }
      for (let i = 0; i < this.marketablePolicyBondForm.highPro.quotaList.length; i++) {
        let item = this.marketablePolicyBondForm.highPro.quotaList[i]
        if (item.minNum === '' || item.minNum === undefined || item.maxNum === '' || item.maxNum === undefined || item.immediate === '' || item.immediate === undefined || item.depositAmount === '' || item.depositAmount === undefined) {
          this.$message.error('请填写完整信息')
          return
        }
      }
      let ordinaryItem = {
        preferentialType: 9,
        itemType: 3, // 商品类型 汽油
        salesOfGradient: this.dealWithQuost(this.marketablePolicyBondForm.ordinaryPro.quotaList) // 订货量梯度json
      }
      // 高级产品 订货量梯度
      let highItem = {
        preferentialType: 9,
        itemType: 4, // 商品类型 柴油
        salesOfGradient: this.dealWithQuost(this.marketablePolicyBondForm.highPro.quotaList) // 订货量梯度json
      }
      let params = [ordinaryItem, highItem]
      this.saveArgeementPolocy({ agreementPolicyVo: params }).then(res => {
        if (res) {
          this.getArgeementSetting(9)
          this.$message.success('保存成功')
        }
      })
    },
    // 获取配置项
    getArgeementSetting (type) {
      let parme = {
        preferentialType: type
      }
      this.getArgeementPolocy(parme).then(res => {
        if (res) {
          for (let i = 0; i < res.length; i++) {
            let item = res[i]
            if (item.itemType === 3) { // 汽油
              // 订货量梯度
              this.marketablePolicyBondForm.ordinaryPro.quotaList = JSON.parse(item.salesOfGradient)
            } else if (item.itemType === 4) { // 柴油
              // 订货量梯度
              this.marketablePolicyBondForm.highPro.quotaList = JSON.parse(item.salesOfGradient)
            }
          }
        }
      })
    },
    // 处理提交时增加订货量梯度
    dealWithQuost (list) {
      let returnList = []
      for (let k = 0; k < list.length; k++) {
        let item = list[k]
        let returnItem = {
          minNum: item.minNum,
          maxNum: item.maxNum,
          immediate: item.immediate,
          nextMonth: item.nextMonth,
          gradientLeve: k,
          depositAmount: item.depositAmount
        }
        if (item.superimposedDiscount) {
          returnItem.superimposedDiscount = item.superimposedDiscount
        }
        returnList.push(returnItem)
      }
      return returnList
    }
  }
}
</script>
<style lang="scss" scoped>
.btn-circle {
  border-radius: 50%;
  color: white;
  padding: 2px;
  cursor: pointer;
  margin: 0 5px;
}
.btn-add {
  background-color: #A6D458;
}
.btn-del {
  background-color: #F46D5E;
}
.add-star{
  >.el-form-item__label{
    /deep/ &:before{
      content: '*';
      color: #f56c6c;
      margin-right: 4px;
    }
  }
}
.pro-row:not(:last-child) {
  margin-bottom: 10px;
}
.nor-text {
  color: black;
}
.card{
  margin-top: 10px;
}

</style>
